import { Button } from 'antd';
import styled from 'styled-components';

export const ToggleButton = styled(Button)`
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 18px;
`;
